import {
    type ApproveCompanyUpdateRequestResponseType,
    type ApproveCompanyUpdateRequestRequestType
} from "./type";
import {
    request
} from "../request";

const approveCompanyUpdateRequest = async (
    params: ApproveCompanyUpdateRequestRequestType
): Promise<ApproveCompanyUpdateRequestResponseType> => {
    return await request<ApproveCompanyUpdateRequestResponseType>(
        "/request/approveCompanyUpdateRequest",
        {
            body: JSON.stringify(params),
            method: "POST"
        }
    );
};
export default approveCompanyUpdateRequest;
